import { render, staticRenderFns } from "./Homepage-Carousel.vue?vue&type=template&id=64412dc2&scoped=true&"
import script from "./Homepage-Carousel.vue?vue&type=script&lang=js&"
export * from "./Homepage-Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Homepage-Carousel.vue?vue&type=style&index=0&id=64412dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64412dc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64412dc2')) {
      api.createRecord('64412dc2', component.options)
    } else {
      api.reload('64412dc2', component.options)
    }
    module.hot.accept("./Homepage-Carousel.vue?vue&type=template&id=64412dc2&scoped=true&", function () {
      api.rerender('64412dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/Homepage-Carousel.vue"
export default component.exports